import { computed, inject, Injectable } from '@angular/core';
import { localDate } from '../../../../shared/pipes/local-date.pipe';
import { SessionService } from '../../../../../services/session.service';
import {
    selectCurrentServiceId,
    selectFolder,
    selectFolderId,
    selectIsFolderTerminated,
    selectServices,
} from '../../../store/person/person.selectors';
import { globalStore } from '../../../../shared/shared.global-service';
import { getSharingFolderIds } from '../../../../../utils/folder.utils';
import { SERVICE_SETTINGS_CARE_PLAN_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class FolderCarePlanPageStore extends ComponentStoreV2Factory {

    public readonly session = inject(SessionService);

    public isTerminated = globalStore!.selectSignal(selectIsFolderTerminated);

    public carePlans = computed(() => {
        const items = this.data.getCarePlans()?.items || [];

        return items.map((item: { createdAt: Date }, index: number) => {
            return {
                ...item,
                createdAt: localDate(item.createdAt, this.session),
                index,
            };
        });
    });

    folder = globalStore!.selectSignal(selectFolder);
    folderId = globalStore!.selectSignal(selectFolderId);
    serviceId = globalStore!.selectSignal(selectCurrentServiceId);

    carePlanSharingIds = computed(() => {
        return getSharingFolderIds(this.serviceId(), globalStore!.selectSignal(selectServices)(), this.folder()?.relatedFolders, SERVICE_SETTINGS_CARE_PLAN_TYPE_KEY);
    });
}
